import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { request } from '@/lib/http';
import { type ConfiguracaoCaptura, configuracaoCapturaRespostaSchema } from '@fiscoai/contracts';

const chave = (empresaId: string) => ['captura', 'configuracao', empresaId] as const;

export function useConfiguracaoCaptura(empresaId: string) {
  return useQuery({
    queryKey: chave(empresaId),
    queryFn: () =>
      request(`/empresas/${empresaId}/captura/configuracao`, {
        schema: configuracaoCapturaRespostaSchema,
      }),
  });
}

export function useSalvarConfiguracaoCaptura(empresaId: string) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (configuracao: ConfiguracaoCaptura) =>
      request(`/empresas/${empresaId}/captura/configuracao`, {
        method: 'PUT',
        body: configuracao,
        schema: configuracaoCapturaRespostaSchema,
      }),
    onSuccess: async (resposta) => {
      cliente.setQueryData(chave(empresaId), resposta);
      // Ligar/desligar e a agenda mudam a situação e a próxima busca.
      await Promise.all([
        cliente.invalidateQueries({ queryKey: ['captura', 'estado', empresaId] }),
        cliente.invalidateQueries({ queryKey: ['captura', 'painel'] }),
      ]);
    },
  });
}
